<div [class]="containerClasses()" role="alert">
  <!-- Icon -->
  <svg
    [class]="iconClasses()"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      [attr.d]="iconPath()"
    />
  </svg>

  <!-- Content -->
  <div class="flex-1 min-w-0">
    <p class="text-sm font-semibold text-bb-text-primary">
      {{ toast().title }}
    </p>
    @if (toast().message) {
      <p class="mt-1 text-sm text-bb-text-secondary">
        {{ toast().message }}
      </p>
    }
  </div>

  <!-- Dismiss button -->
  @if (toast().dismissible) {
    <button
      type="button"
      class="flex-shrink-0 p-1 rounded text-bb-text-secondary hover:text-bb-text-primary hover:bg-bb-bg-tertiary transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-bb-accent-blue"
      (click)="onDismiss()"
      aria-label="Dismiss"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  }
</div>
